import React, { FC } from 'react';
import { ReorderWarning } from './ReorderWarning';
import { MinimumDeliveryAmountWarning } from 'components/MinimumDeliveryAmountWarning';

type WarningBannerProps = {
  onClick?: () => void;
};

export const WarningBanner: FC<WarningBannerProps> = ({ onClick }) => {
  return (
    <>
      <ReorderWarning onClick={onClick} />
      <MinimumDeliveryAmountWarning onAddMoreClick={onClick} />
    </>
  );
};
